<template>
  <div>
    <!-- Display a dialog if there's an issue like if we're offline or the user config couldn't be laoded -->
    <v-dialog
        :value="displayDialog"
        persistent
        transition="dialog-bottom-transition"
        max-width="500">
      <v-card>
        <v-toolbar
            color="error"
            flat>
          <v-card-title class="text-h5 white--text">
            <v-icon
                v-if="userConfigNotLoadedErrorMessage && onlineStatus"
                large
                color="white"
                class="mr-5">
              mdi-alert-circle-outline
            </v-icon>
            {{ titleToDisplay }}
          </v-card-title>
        </v-toolbar>

        <v-card-text
            class="body-1 pa-5">
          {{ messageToDisplay }}
        </v-card-text>

        <template
            v-if="userConfigNotLoadedErrorMessage">
          <v-divider/>

          <v-card-actions>
            <v-spacer/>
            <v-btn
                color="error"
                text
                @click="logOut">
              Log out
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
    <!-- When we've been offline and return to being online, display a (non-intrusive) snackbar
       After a default timeout of 5 seconds, the snackbar will reset the backOnline variable
       and it will disappear by itself, so this functionality can be used again if the user times out again -->
    <v-snackbar
        v-model="backOnline"
        color="success"
        text>
      Panel is back online.
    </v-snackbar>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import store from '@/store';

/**
 * This component is used for displaying errors on the panel
 * if the user config failed to load or the panel goes offline
 */
export default {
  props: {
    roomNameProp: {
      type: String,
      default: 'This'
    }
  },
  computed: {
    ...mapState('offline', ['onlineStatus', 'justBackOnline']),
    ...mapState('config', ['userConfigNotLoadedErrorMessage']),
    backOnline: {
      get() {
        return this.justBackOnline;
      },
      set(v) {
        this.changeJustBackOnline(v);
      }
    },
    /**
     * If not logged in, the roomNameProp will be ''
     * So manually assign an appropriate placeholder value
     * @return {String}
     */
    roomName() {
      if (this.roomNameProp.length === 0) {
        return 'This';
      }

      return this.roomNameProp;
    },
    /**
     * Should we display the dialog or not?
     * @return {Boolean}
     */
    displayDialog() {
      return !this.onlineStatus || this.userConfigNotLoadedErrorMessage;
    },
    titleToDisplay() {
      if (!this.onlineStatus) {
        return `${this.roomName} panel is offline`;
      }

      return `${this.roomName} panel failed to load the config`;
    },
    messageToDisplay() {
      if (!this.onlineStatus) {
        return `This panel is offline. Please contact your support team.`;
      }

      return `${this.userConfigNotLoadedErrorMessage} Please contact your support team.`;
    }
  },
  methods: {
    ...mapMutations('offline', ['changeOnlineStatus', 'changeJustBackOnline']),
    ...mapActions('serviceWorker', ['reload']),
    /**
     * If the user configuration fails to load, we want to give the user the opportunity to sign out and sign in again
     */
    logOut() {
      store.dispatch('auth/signOut')
          .catch(err => this.$logger.warn(`Error during logout: ${err}`))
          .then(() => this.reload());
    }
  }
};
</script>

<style scoped>

</style>
